import React from 'react'
import {
    Box,
    Button,
    Container,
    Heading,
    HStack,
    Icon,
    Text,
    VStack,
} from '@chakra-ui/react'
import { MdLock } from 'react-icons/md'
import { useLocation, useNavigate } from 'react-router-dom'

const Forbidden = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const state = location.state || {}
    const message = state.message || "You don't have permission to access this resource."

    return (
        <Container maxW="3xl" py={8} mt={20}>
            <Box bg="white" shadow="md" borderRadius="md" p={10} textAlign="center">
                <VStack spacing={5}>
                    <Icon as={MdLock} boxSize={16} color="red.400" />
                    <Heading as="h1" size="xl">403</Heading>
                    <Heading as="h2" size="md" color="gray.700">
                        Access forbidden
                    </Heading>
                    <Text color="gray.600" maxW="md">
                        {message}
                    </Text>
                    {state.from && (
                        <Text fontSize="sm" color="gray.400">
                            Requested: {state.from}
                        </Text>
                    )}
                    <HStack spacing={3} pt={2}>
                        <Button variant="outline" onClick={() => navigate(-1)}>
                            Go back
                        </Button>
                        <Button colorScheme="blue" onClick={() => navigate('/admin/default')}>
                            Go to dashboard
                        </Button>
                    </HStack>
                </VStack>
            </Box>
        </Container>
    )
}

export default Forbidden
